import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import EditNoteIcon from '@mui/icons-material/EditNote';
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SwipeIcon from "@mui/icons-material/Swipe";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsSubwayFilledIcon from '@mui/icons-material/DirectionsSubwayFilled';
import { DataObject, Fireplace } from "@mui/icons-material";
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import CropDinIcon from '@mui/icons-material/CropDin';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
export const SidebarData = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: <HomeIcon className="sideBar-icon" />,
  },
  {
    title: "cadastro",
    path: "",
    permission: ["DEV"],
    icon: <CollectionsBookmarkIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "bloco",
        path: "/bloc",
        cName: "sub-nav",
        permission: ["DEV", "a"],
      },
      {
        title: "combinacoes",
        path: "/combinacoes",
        cName: "comb-piece",
        permission: ["Combinacoes"],
      },
      {
        title: "equipamento",
        path: "/equipment",
        cName: "sub-nav",
        permission: ["DEV"],
      },
      {
        title: "fabricante",
        path: "/manufacturer",
        cName: "sub-nav",
        permission: ["DEV"],
      },
      {
        title: "mensagemSetor",
        path: "/mensagem-setor",
        cName: "mensagem-setor",
        permission: ["Mensagem"],
      },
      {
        title: "motivo",
        path: "/reason",
      },
      {
        title: "perguntas",
        path: "/questions",
      },
      {
        title: "perguntaSetor",
        path: "/registerQuestionSector",
      },
      {
        title: "setor",
        path: "/sector",
        cName: "sub-nav",
        permission: ["DEV"],
      },
      {
        title: "skuEquip",
        path: "/skuequipment",
        cName: "sub-nav",
        permission: ["DEV"],
      },
    ],
  },
  {
    title: "engenharia",
    path: "",
    permission: ["Engenharia_tela"],
    icon: <SquareFootIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "partsInDevelopment",
        path: "/parts-in-development",
        cName: "sub-nav",
        permission: ["Engenharia_tela"],
      },
    ],
  },
  {
    title: "fotolito",
    icon: <CropDinIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "CriarTelas",
        path: "/fotolito",
        cName: "sub-nav",
      },
      {
        title: "HistoricoTelas",
        path: "/hitoricoTelas",
        cName: "sub-nav",
      },
      {
        title: "ListaOrdens",
        path: "/listaOrdens",
        cName: "sub-nav",
      }
    ],
  },

  {
    title: "logistica",
    path: "",
    icon: <LocalAirportIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "validacaoLogo",
        path: "/validacao-logo",
        cName: "sub-nav",
        //permission: ["ISAGA_ValidaLOGO"],
      },
      {
        title: "historicLogo",
        path: "/historic-logo",
        cName: "sub-nav",
        //permission: ["ISAGA_ValidaLOGO"],
      },
    ],
  },
  {
    title: "fornos",
    permission: ["TelaFornos"],
    icon: <Fireplace className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "painelFornos",
        path: "/wagon",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "vagoesAprovados",
        path: "/vagoesAprovados",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "moldes",
        path: "/moldes",
        cName: "sub-nav",
        permission: ["Moldes", "TelaFornos"],
      },
      {
        title: "manutencao",
        path: "/manutencao",
        cName: "sub-nav",
        permission: ["Manutencao", "TelaFornos"],
      },
      {
        title: "historicWagon",
        path: "/historic-wagon",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "statusMolde",
        path: "/status-molde",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "wagonsAnalise",
        path: "/wagons-to-analyze",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "sapnotifications",
        path: "/sapnotifications",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
      {
        title: "rastrearPices",
        path: "/rastrear-peças",
        cName: "sub-nav",
        permission: ["TelaFornos"],
      },
    ]
  },
  {
    title: "Apontamentos",
    icon: <EditNoteIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "Apontamentos",
        path: "/Apontamento_SAP",
        icon: <EditNoteIcon className="sideBar-icon" />,
      },
      {
        title: "Historico",
        path: "/Apontamento_SAP/Historico",
        icon: <AssignmentIcon className="sideBar-icon" />,
      },
    ]
  },
  {
    title: "Prioridade_PCP",
    path: "/Prioridade_PCP",
    icon: <PriorityHighIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
  },
  // {
  //   title: "ocorrencias",
  //   path: "",
  //   permission: ["DEV"],
  //   icon: <ErrorOutlineIcon className="sideBar-icon" />,
  //   iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
  //   iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
  //   subNav: [
  //     {
  //       title: "tipoOcorrencia",
  //       path: "/typeOccurrence",
  //       cName: "sub-nav",
  //       permission: ["DEV"],
  //     },
  //     {
  //       title: "ocorrencia",
  //       path: "/occurrence",
  //       cName: "sub-nav",
  //       permission: ["DEV"],
  //     },
  //   ],
  // },
  // {
  //   title: "questionario",
  //   path: "/questionSector",
  //   permission: ["DEV"],
  //   icon: <QuestionMarkIcon className="sideBar-icon" />,
  // },
  {
    title: "reprocesso",
    path: "/Reprocess",
    permission: ["Reprocesso_tela"],
    icon: <SwipeIcon className="sideBar-icon" />,
  },
  {
    title: "docExercito",
    path: "/DocumentosExercito",
    permission: ["Invoice", "DEV"],
    icon: <AssignmentIcon className="sideBar-icon" />,
  },
  {
    title: "instrutivos",
    path: "/instrutivos",
    permission: ["DEV"],
    icon: <AutoStoriesIcon className="sideBar-icon" />,
  },

  {
    title: "Portaria",
    icon: <ContactEmergencyIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    permission: ["Portaria"],
    subNav: [

      {
        title: "Portaria",
        path: "/portaria",
        cName: "sub-nav",
        permission: ["Portaria"]
      },
      {
        title: "Entradas",
        path: "/entradas",
        cName: "sub-nav",
        permission: ["Portaria"]
      },
      {
        title: "Pessoas",
        path: "/pessoas",
        cName: "sub-nav",
        permission: ["Portaria"]
      }

    ]
  },

  {
    title: "permissoes",
    path: "",
    permission: ["DEV"],
    icon: <ManageAccountsIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "usuarios",
        path: "/userPermission",
        cName: "sub-nav",
        permission: ["DEV"],
      },
      {
        title: "grupos",
        path: "/groupPermission",
        cName: "sub-nav",
        permission: ["DEV"],
      },
    ],
  },
  {
    title: "devConfig",
    path: "/barcodeGeneration",
    permission: ["DEV"],
    icon: <DataObject className="sideBar-icon" />,
  },
  {
    title: "config",
    path: "",
    icon: <SettingsIcon className="sideBar-icon" />,
    iconClosed: <ArrowDropDownIcon className="sideBar-icon" />,
    iconOpened: <ArrowDropUpIcon className="sideBar-icon" />,
    subNav: [
      {
        title: "configUser",
        path: "/UpdateUser",
      },
      {
        title: "configPieceSector",
        path: "/configPieceSector",
        permission: ["DEV"],
      }
    ],
  },

];
